import React, { useState, useContext, useEffect, useRef } from 'react';
import { Clock, Check, X, Type, Inbox, PenTool, FileText, Users as Team,CreditCard, Clipboard, User, Info, Menu, Minimize2, Maximize2, Bell, ChevronDown, Tag } from 'react-feather';

import { languages } from '../../Data/languages';

import { NotificationContext } from '../../Context/NotificationContext';
import { DataContext } from '../../Context/DataContext';
import { useScreenTransition } from '../../Hooks/useScreenTransition';
import { auth, firestore } from '../../firebase.config';
import './Translations.css';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';
import { useSpring } from 'react-spring';
const pageLimit = 50;

const OwnTranslations = ({ windowSize }) => {
  let { path, url } = useRouteMatch();

  const { clearSignOut } = useContext(AuthContext);

  const location = useLocation();

  const [sidebarPeek, setSidebarPeek] = useState(false);
  const [openMain, setOpenMain] = useState(false);

  const [mobileOpen, setMobileOpen] = useState(false);

  const desktopScreen = windowSize.width > 1024 || windowSize.orientation === 'landscape';

  const mobileMenuProps = useSpring({ width: mobileOpen ? (windowSize.width > 767 ? 'calc(40vw)' : 'calc(70vw)') : 'calc(0vw)' });
  const mobileInnerContainerProps = useSpring({ width: 'calc(100vw)' });

  const innerContainerProps = useSpring({ width: !openMain ? (windowSize.width > 1024 ? 'calc(82vw)' : 'calc(82vw)') : 'calc(99.7vw)' });
  const sidebarProps = useSpring({ width: !openMain || sidebarPeek ? (windowSize.width > 1024 ? 'calc(18vw)' : 'calc(18vw)') : 'calc(0.3vw)' });

  const sidebarBadgesProps = useSpring({ opacity: !openMain || sidebarPeek ? 1 : 0 });

  const [invoices, setInvoices] = useState([]);
  const [quotes, setQuotes] = useState([]);

  const [lastNotification, setLastNotification] = useState(0);


  const { transitionTo } = useScreenTransition()

  const { showNotification } = useContext(NotificationContext);

  const { userData } = useContext(DataContext);

  const [orders, setOrders] = useState([]);
  const [loadedOrders, setLoadedOrders] = useState(false);

  const orderSearchRef = useRef();
  const [orderSearch, setOrderSearch] = useState('');

  const [dueSort, setDueSort] = useState(false);

  const [statusFilter, setStatusFilter] = useState('');

  const [triggerFilter, setTriggerFilter] = useState(true);

  let firstLoad = useRef();
  if (!firstLoad.current) firstLoad.current = true;

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
    const applyOrder = e => {
      if (e.keyCode === 13) {
        setTriggerFilter(tf => !tf);
      }
    }

    const orderSearchRefVar = orderSearchRef.current;

    orderSearchRef.current.addEventListener("keyup", applyOrder);

    return () => {
      orderSearchRefVar.removeEventListener("keyup", applyOrder);
    }
  }, []);

  useEffect(() => {
    if (userData) {
      firstLoad.current = true;

      

      let query = firestore.collection('orders');

      if (orderSearch !== '') {
        query = query.where('orderNumber', '==', parseInt(orderSearch,10));
      };

      if (statusFilter !== '') {
        query = query.where('status', '==', statusFilter);
      };

      if (dueSort) {
        query = query.orderBy('due', 'asc')
      } else {
        query = query.orderBy('timestamp', 'desc');
      }

      const unsubscribe = 
        query
          .where('translator.id', '==', userData.id)
          .limit(pageLimit)
          .onSnapshot(querySnapshot => {
            if (firstLoad.current) {
              nextPointer.current = querySnapshot.docs[querySnapshot.docs.length-1];
              firstLoad.current = false;
              
              setOrders(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
              setLoadedOrders(true);
            } else {
              let newOrders = [];

              querySnapshot.docChanges().forEach((change) => {
                if (change.type === "added") {
                  newOrders.push({ id: change.doc.id, ...change.doc.data() });
                }
              });
              
              setOrders(u => newOrders.concat(u));
              setLoadedOrders(true);
            }
          }, error => {
            //console.log(error);
            showNotification('Error', "There was an error loading the orders. Please, reload the page.", 'error');
            setLoadedOrders(true);
          });

      return () => unsubscribe();
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, triggerFilter, dueSort, statusFilter]);

  const loadMoreOrders = () => {
    if (nextPointer.current && userData) {
      
      let query = firestore.collection('orders');

      if (orderSearch !== '') {
        query = query.where('orderNumber', '==', orderSearch);
      };

      if (statusFilter !== '') {
        query = query.where('status', '==', statusFilter);
      };

      if (dueSort) {
        query = query.orderBy('due', 'desc')
      } else {
        query = query.orderBy('timestamp', 'desc');
      }

      query
        .where('translator.id', '==', userData.id)
        .startAfter(nextPointer.current)
        .limit(pageLimit)
        .get().then((querySnapshot) => {
          nextPointer.current = querySnapshot.docs[querySnapshot.docs.length-1];

          let oldOrders = [];

          querySnapshot.forEach((doc) => {
            oldOrders.push({ id: doc.id, ...doc.data() });
          });
          
          setOrders(u => u.concat(oldOrders));
        })
        .catch((error) => {
          showNotification('Error', "There was an error loading the orders. Please, reload the page.", 'error');
          //console.log("Error getting documents: ", error);
        });
    }
  }

  const formatDue = timestamp => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(' ');

    return splitted[1] + ' ' + splitted[2] + ', ' + splitted[3] + ' @ ' + date.toTimeString().substr(0, 5);
  }

  const handleSignOut = () => {
    auth.signOut()
      .then(() => {
        showNotification('Success', 'You have successfully signed out.', 'success');
        clearSignOut();
        transitionTo('/');
      })
      .catch(error => {
        showNotification('Error', 'There was an error signing out. Please, try again. If it persists, please contact technical support.', 'error');
      })
  }

  const toggleMenu = () => {
    setMobileOpen(i => !i);
  }


  return (

    <div className="backendOuterContainer" style={{ height: windowSize.height }}>
    <div style={desktopScreen ? sidebarProps : mobileMenuProps} onMouseEnter={desktopScreen ? () => setSidebarPeek(true) : null} onMouseLeave={desktopScreen ? () => setSidebarPeek(false) : null} className="backendSidebar">
      <div className="backendLogoContainer">
        <img src={require('../../assets/logoAlt.png')} alt="Logo eVerbary" className="backendLogo" onClick={(e) => transitionTo('/',e)} />
        <X className="backendCloseSidebarIcon" onClick={() => toggleMenu()} />
      </div>
      <div className="backendSidebarLinksContainer">
        {userData && userData.role === 'Translator' && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('translations') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/translations') || e.ctrlKey) {transitionTo(`${url}/translations`,e); setMobileOpen(false);}}} className="backendSidebarLink">
            <Type className="backendSidebarLinkIcon" />
            Translations
            <div style={sidebarBadgesProps} className="backendSidebarLinkExtraIconContainer">
              {orders.filter(order => order.status === 'assigned').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#61dbfb' }}>
                  {orders.filter(order => order.status === 'assigned').length}
                </div>
              }
              {orders.filter(order => order.status === 'in-progress').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#1491F8' }}>
                  {orders.filter(order => order.status === 'in-progress').length}
                </div>
              }
            </div>
          </div>
        </div>}
        {userData && (userData.role === 'owner' || userData.role === 'Support') && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('translations') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) =>{if(!location.pathname.includes('/translations') || e.ctrlKey) { transitionTo(`${url}/translations`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Type className="backendSidebarLinkIcon" />
            Orders
            <div style={sidebarBadgesProps} className="backendSidebarLinkExtraIconContainer">
              {orders.filter(order => order.status === 'new').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#FF7C1D' }}>
                  {orders.filter(order => order.status === 'new').length}
                </div>
              }
              {orders.filter(order => order.status === 'assigned').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#61dbfb' }}>
                  {orders.filter(order => order.status === 'assigned').length}
                </div>
              }
              {orders.filter(order => order.status === 'in-progress').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#1491F8' }}>
                  {orders.filter(order => order.status === 'in-progress').length}
                </div>
              }
              {orders.filter(order => order.status === 'support-review').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#e91e63' }}>
                  {orders.filter(order => order.status === 'support-review').length}
                </div>
              }
              {orders.filter(order => order.status === 'revision').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#333' }}>
                  {orders.filter(order => order.status === 'revision').length}
                </div>
              }
            </div>
          </div>
        </div>}
        {userData && userData.role === 'Translator' && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('revisions') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/revisions') || e.ctrlKey) {transitionTo(`${url}/revisions`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Inbox className="backendSidebarLinkIcon" />
            Revisions
            <div style={sidebarBadgesProps} className="backendSidebarLinkExtraIconContainer">
              {orders.filter(order => order.status === 'revision').length > 0 && 
                <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#333' }}>
                  {orders.filter(order => order.status === 'revision').length}
                </div>
              }
            </div>
          </div>
        </div>}
        {userData && (userData.role === 'owner' || userData.role === 'Support') && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('quotes') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/quotes') || e.ctrlKey) {transitionTo(`${url}/quotes`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <PenTool className="backendSidebarLinkIcon" />
            Quotes
            {userData && (userData.role === 'owner' || userData.role === 'Support') &&
              <div style={sidebarBadgesProps} className="backendSidebarLinkExtraIconContainer">
                {quotes.length > 0 && 
                  <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#FF7C1D' }}>
                    {quotes.length}
                  </div>
                }
              </div>
            }
          </div>
        </div>}
        <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('invoices') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) =>  {if(!location.pathname.includes('/invoices') || e.ctrlKey) {transitionTo(`${url}/invoices`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <FileText className="backendSidebarLinkIcon" />
            Invoices
            {userData && (userData.role === 'owner' || userData.role === 'Support') &&
              <div style={sidebarBadgesProps} className="backendSidebarLinkExtraIconContainer">
                {invoices.length > 0 && 
                  <div className="backendSidebarExtraIcon" style={{ backgroundColor: '#AE5FD2' }}>
                    {invoices.length}
                  </div>
                }
              </div>
            }
          </div>
        </div>
        <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('payments') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) =>  {if(!location.pathname.includes('/payments') || e.ctrlKey) {transitionTo(`${url}/payments`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <CreditCard className="backendSidebarLinkIcon" />
            Payments
          </div>
        </div>
        {userData && (userData.role === 'owner' || userData.role === 'Support') && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('clients') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/clients') || e.ctrlKey){ transitionTo(`${url}/clients`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Clipboard className="backendSidebarLinkIcon" />
            Clients
          </div>
        </div>}
        {userData && userData.role === 'owner' && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('users') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/users') || e.ctrlKey) {transitionTo(`${url}/users`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <User className="backendSidebarLinkIcon" />
            Users
          </div>
        </div>}
        {userData && (userData.role === 'owner' || userData.role === 'Support') && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('teams') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/teams') || e.ctrlKey) {transitionTo(`${url}/teams`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Team className="backendSidebarLinkIcon" />
            Teams
          </div>
        </div>}
        {userData && (userData.role === 'owner' || userData.role === "Support") && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('coupons') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/coupons') || e.ctrlKey) {transitionTo(`${url}/coupons`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Tag className="backendSidebarLinkIcon" />
            Coupons
          </div>
        </div>}
        {userData && userData.role === 'Translator' && <div className="backendSidebarLinkContainer">
          <div style={{ color: location.pathname.includes('guidelines') ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.4)' }} onClick={(e) => {if(!location.pathname.includes('/guidelines') || e.ctrlKey) {transitionTo(`${url}/guidelines`,e); setMobileOpen(false); }}} className="backendSidebarLink">
            <Info className="backendSidebarLinkIcon" />
            Guidelines
          </div>
        </div>}
      </div>
    </div>
    <div style={desktopScreen ? innerContainerProps : mobileInnerContainerProps} className="backendInnerContainer">
      <div className="backendHeader">
        { !desktopScreen
        ? <Menu className="backendSwitchIcon" onClick={() => toggleMenu()} /> 
        : openMain 
          ? <Minimize2 className="backendSwitchIcon" onClick={() => setOpenMain(false)} /> 
          : <Maximize2 className="backendSwitchIcon" onClick={() => setOpenMain(true)} /> 
        }
        <div className="backendHeaderOptionsContainer">
          <Bell className="backendSwitchIcon" color={userData && userData.readNotifications && userData.readNotifications < lastNotification ? '#FF7C1D' : '#666'} onClick={(e) => transitionTo('/office/notifications',e)} />
          <div className="backendHeaderOptionsSeparator" />
          <div className="backendHeaderOptionsMenuContainer">
            <p className="backendHeaderOptionsName">{userData && userData.name}</p>
            <ChevronDown className="backendHeaderOptionsIcon" />
            <div className="backendHeaderOptionsMenuInner">
              <p className="backendHeaderOptionsMenuLink" onClick={(e) => transitionTo('/office/preferences',e)}>Preferences</p>
              <p className="backendHeaderOptionsMenuLink" onClick={handleSignOut}>Logout</p>
            </div>
          </div>
        </div>
      </div>
      <div className="backendTabContainer">
      <div className="translationsContainer">
      <div className="translationsInnerContainer">
        <div className="translationsTitleRow">
          <p className="translationsTitle">Translations</p>
          <div className="usersFunctionsContainer">
            <div className="userLanguageFilterContainer">
              <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="quoteDetailsSelect">
                <option key="" value="">All</option>
                <option key="assigned" value="assigned">Assigned</option>
                <option key="in-progress" value="in-progress">In Progress</option>
                <option key="completed" value="completed">Completed</option>
                <option key="cancelled" value="cancelled">Cancelled</option>
              </select>
            </div>
            <div onClick={() => setDueSort(d => !d)} className="userFunctionsCheckboxContainer">
              <div className="userFunctionsCheckbox">
                <Check className="userFunctionsCheck" style={{ opacity: dueSort ? 1 : 0 }} />
              </div>
              Sort by due date
            </div>
            <div className="userLanguageFilterContainer" style={{ marginRight: 0 }}>
              <input type="text" value={orderSearch} ref={orderSearchRef} onChange={(e) => setOrderSearch(e.target.value)} className="userNameFilter" placeholder="Search by order number" />
            </div>
          </div>
        </div>
        <div className="translationsTableHeader">
          <div className="usersHeaderColumn translationsTimerColumn">
            <Clock className="translationsColumnIcon" />
          </div>
          <div className="usersHeaderColumn translationsOrderColumn">Order</div>
          <div className="usersHeaderColumn translationsInvoiceColumn">Invoice</div>
          <div className="usersHeaderColumn translationsLanguageColumn">From</div>
          <div className="usersHeaderColumn translationsLanguageColumn">To</div>
          <div className="usersHeaderColumn translationsDueColumn">Due</div>
          <div className="usersHeaderColumn translationsStatusColumn">Status</div>
        </div>
        { loadedOrders && orders.length > 0
        ? orders.map(order => 
          <div key={order.id} className="translationsTableLine">
            <div className="usersLineColumn translationsTimerColumn">{order.expedited ? <Clock className="translationsColumnIcon translationsLineColumnIcon" /> : null}</div>
            <div className="usersLineColumn translationsOrderColumn" style={{ cursor: 'pointer', color: '#609ddb' }} onClick={(e) => transitionTo('/office/translation/' + order.id + "/details",e)}>{order.orderNumber}</div>
            <div className="usersLineColumn translationsInvoiceColumn" style={{ cursor: 'pointer', color: '#609ddb' }} onClick={(e) => transitionTo('/office/translation/' + order.id + "/invoice",e)}>{order.status !== 'new' && order.status !== 'assigned' && order.invoice &&  order.invoice.invoiceNumber}</div>
            <div className="usersLineColumn translationsLanguageColumn">{languages.find(language => language.value === order.languageFrom) ? languages.find(language => language.value === order.languageFrom).label : null}</div>
            <div className="usersLineColumn translationsLanguageColumn">{languages.find(language => language.value === order.languageTo) ? languages.find(language => language.value === order.languageTo).label : null}</div>
            <div className="usersLineColumn translationsDueColumn">{order.due ? formatDue(order.due) : ''}</div>
            <div className="usersLineColumn translationsStatusColumn">
              <div className="translationsStatusContainer" style={{ backgroundColor: order.status === 'new' ? '#FF7C1D' : order.status === 'assigned' ? '#61dbfb' : order.status === 'in-progress' ? '#1491F8' : order.status === 'cancelled' ? '#E1504A' : '#17BC5B' }}>
                { order.status === 'new' ? "NEW ORDER" : order.status === 'assigned' ? 'ASSIGNED' : order.status === 'in-progress' ? 'IN PROGRESS' : order.status === 'cancelled' ? 'CANCELLED' : 'COMPLETED'}
              </div>
            </div>
          </div>)
        : loadedOrders ? <div className="loadingTranslations">No orders.</div> : <div className="loadingTranslations">Loading orders<span className="dotsLoading">...</span></div>
        }
        { loadedOrders && orders.length >= 50 && nextPointer.current &&
          <div className="loadMoreUsersButton" onClick={() => loadMoreOrders()}>
            Load more orders...
          </div>
        }
      </div>
    </div>
      </div>
    </div>
  </div>

  
  );
};

export default OwnTranslations;